import { MessageItemAstrolog } from "./MessageItemAstrolog";
import { MessageItemYour } from "./MessageItemYour";
import { ChatMessageUi, FetchDirection } from "../ChatScreenViewModel";
import { Virtuoso, VirtuosoHandle } from "react-virtuoso";
import { useEffect, useRef } from "react";

interface ChatMessagesProps {
  messages: ChatMessageUi[];
  skipUp: number;
  skipDown: number;
  fetchItems: (direction: FetchDirection) => void;
  loading: { up: boolean; down: boolean };
}

const ChatMessages = ({
  messages,
  skipUp,
  fetchItems,
}: ChatMessagesProps) => {
  const virtuosoRef = useRef<VirtuosoHandle>(null);
  const scrollerRef = useRef<HTMLDivElement | null>(null);

  // Инвертируем скролл колеса мыши
  const handleWheel = (e: WheelEvent) => {
    e.preventDefault();
    if (scrollerRef.current) {
      scrollerRef.current.scrollTop -= e.deltaY; // Инверсная прокрутка
    }
  };

  // Вешаем обработчик на контейнер Virtuoso
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;

    scroller.addEventListener("wheel", handleWheel, { passive: false });
    return () => scroller.removeEventListener("wheel", handleWheel);
  }, []);

  return (
      <Virtuoso
      ref={virtuosoRef}
      scrollerRef={(ref) => {
        if (ref) {
          scrollerRef.current = ref as HTMLDivElement;
        }
      }}
        style={{ flexDirection: "column-reverse", height: "100vh", transform: "scaleY(-1)" }}
        data={messages}
        firstItemIndex={Math.max(0, skipUp)}
        startReached={() => fetchItems(FetchDirection.Up)}
        endReached={() => fetchItems(FetchDirection.Down)}
        itemContent={(index, item) => item.isUserMessage ? (
              <MessageItemYour message={item} key={index} />
            ) : (
              <MessageItemAstrolog message={item} key={index} />
            )}
      />
  );
};

export default ChatMessages;